/**
 * «Mostrar la guía en» (Ajustes de activación): todos los dispositivos, solo
 * escritorio y tablets, o solo móvil. Se decide en el cliente por el ancho del
 * viewport (móvil = < 768px, el corte habitual). Función pura para testear.
 */
import type { ActivationDevices } from './types';

export const MOBILE_MAX_WIDTH = 767;

export function isDeviceAllowed(
  devices: ActivationDevices | null | undefined,
  viewportWidth: number = typeof window === 'undefined' ? 1024 : window.innerWidth,
): boolean {
  if (!devices || devices === 'all') return true;
  const mobile = viewportWidth <= MOBILE_MAX_WIDTH;
  return devices === 'mobile' ? mobile : !mobile;
}
